/** The one scheme a Mirror file's address may be opened with (SEC-1). */
const HTTPS_PROTOCOL = 'https:';

/** Ported from Clarity `apps/web/src/features/domains/components/FileViewer.tsx` (commit `6750a5f43`). */
/**
 * A Mirror file's address at its provider — `ClarityMirrorIdentity.webUrl` — when it may be opened, else `null`:
 * the EFF-26321 spec's **SEC-1**, the one shared address rule.
 *
 * Brain opens any non-null `webUrl` (`file?.external?.webUrl ?? null`, `FileViewer.tsx:589`, then `window.open` at
 * `:815`), and its mapper copies the address as the row carries it (`_domainMappers.ts:42`). Here an address that
 * does not parse as an absolute URL, or whose scheme is not `https:`, counts as absent — so a server-supplied
 * `javascript:`, `data:` or `http:` address never reaches a link or `window.open`. A present address is answered as
 * the row carries it, not normalised, so what opens is what brain would open.
 *
 * **For every surface that opens a mirror's address.** The Domain file viewer's "Open in SharePoint" reads it
 * (EFF-26321), as do the file browser's Mirror menu and the Documents viewer header's "Open in SharePoint"
 * (`ClarityDomainDocumentView.externalWebUrl`).
 *
 * @param webUrl The mirror's address, or nothing when the row carries none.
 * @returns The address when it parses and is `https:`, else `null`.
 */
export function readClarityMirrorWebUrl(webUrl: string | null | undefined): string | null {
	if (webUrl === null || webUrl === undefined) {
		return null;
	}

	try {
		return new URL(webUrl).protocol === HTTPS_PROTOCOL ? webUrl : null;
	} catch {
		// Not an absolute URL: SEC-1 counts it as absent.
		return null;
	}
}
